var plugin_rtlignore_default = {
  "alignLeft": "_7QZD4",
  "textWrapNowrap": "ZQKub",
  "alignRight": "uBnPD",
  "alignCenter": "JSD3p",
  "sizeFullWidth": "PDPba",
  "renderedInTable": "PoFTm",
  "sizeOriginal": "kc9E-",
  "sizeContent": "l43X9",
  "sizeSmall": "-rYql",
  "sizeSmallCenter": "Tb2Ul",
  "flex": "TCrEK",
  "atomic": "M8gRS",
  "embed": "-sT8k",
  "horizontalScrollbar": "-ug4U",
  "pluginContainerMobile": "ZyG2L"
};
export {
  plugin_rtlignore_default as default
};
//# sourceMappingURL=plugin.rtlignore-scss.js.map
